import React from 'react';
import defaultProductImage from "assets/img/no_product.png";
import { Avatar } from '@material-ui/core';

export default (props) => {
    const { image, classes, style, className } = props;
    return (
        <Avatar
            alt="..."
            classes={classes}
            className={className}
            style={style}
            src={image ? ("/api/image/get?id=" + image) : defaultProductImage}
        />
    );
}
